import { render, staticRenderFns } from "./KeywordImport.vue?vue&type=template&id=1686a236&"
import script from "./KeywordImport.vue?vue&type=script&lang=js&"
export * from "./KeywordImport.vue?vue&type=script&lang=js&"
import style0 from "./KeywordImport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports